'use strict';

var _root = require('./_root.js');

var root = _root;

/** Built-in value references. */
var Symbol = root.Symbol;

var _Symbol = Symbol;

module.exports = _Symbol;
